import styled from "@emotion/styled"
import { radiusXl } from "@porsche-design-system/components-react/emotion"
import { SkeletonText } from "./SkeletonText"

export const SkeletonTagDismissible = styled(SkeletonText)<{ $width?: string }>`
	min-height: 56px;
	width: ${({ $width }) => $width ?? "160px"};
	border-radius: ${radiusXl};
`
